
<bolt-modal id="tellUsMoreModal"
    heading="Tell us more"
    #tellUsMoreModal
    type="question">
    <bolt-notification class="bolt-space-bottom-md" *ngIf="apiError">
        We're having some trouble. Give us a call so we can help you. <a href="tel:1-800-421-3535">1-800-421-3535</a>.
    </bolt-notification>
    <div>
        <form [formGroup]="tellUsMoreForm">
            <bolt-textarea ngDefaultControl
                name="note"
                required
                maxlength="1000"
                formControlName="note"
                label="Enter any new information about your claim here, and we'll add it to your file."
                optionaltext="hide"
                showcount
                [attr.error]="formError.checkForError(tellUsMoreForm, 'note')"
                id="tellUsMoreModal_NoteTextField">
            </bolt-textarea>
        </form>
    </div>
    <bolt-button-bar slot="modal-button-bar">
        <bolt-button (click)="submit()" [disabled]="!tellUsMoreForm?.valid" slot="forward" type="solid">Submit</bolt-button>
        <bolt-button (click)="close()" slot="cancel">Cancel</bolt-button>
    </bolt-button-bar>

</bolt-modal>
